"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _es6Promise = _interopRequireDefault(require("es6-promise"));

require("whatwg-fetch");

var _settingsUserManagement = _interopRequireDefault(require("./../settings-user-management"));

var _translate = _interopRequireDefault(require("../translate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

_es6Promise.default.polyfill();

var Settings = /*#__PURE__*/function (_React$Component) {
  _inherits(Settings, _React$Component);

  function Settings(props) {
    _classCallCheck(this, Settings);

    return _possibleConstructorReturn(this, (Settings.__proto__ || Object.getPrototypeOf(Settings)).call(this, props));
  }

  _createClass(Settings, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/_react.default.createElement("h1", null, t('Settings')), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          marginBottom: '25px'
        }
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "large-4",
        href: "/programs"
      }, /*#__PURE__*/_react.default.createElement("span", null, this.props.t('Zur Programmliste')))), /*#__PURE__*/_react.default.createElement(_settingsUserManagement.default, null)));
    }
  }]);

  return Settings;
}(_react.default.Component);

Settings.propTypes = {
  t: _propTypes.default.func.isRequired
};

var _default = (0, _translate.default)(Settings);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/settings/index.js
// module id = 724
// module chunks = 0